import { gql } from '@apollo/client';

export const GET_PUBLISHER_LIST_V4 = gql`
  query GET_PUBLISHER_LIST_V4 {
    getPublisherListV4 {
      id
      name
    }
  }
`;
